export class Performances {
  objectifs: Array<Objectifs>;
  constructor() {
  }
}

export class Objectifs {
  id: number;
  description: string;
  barem_id: string;
  indicateur: string;
  delai: string;
  cible: string;
  notations: Array<Notations>;
  constructor(notations: Array<Notations>, id: number) {
    this.id = id;
    this.notations = notations;
  }
}

export class Notations {
  id: number;
  libelle: string;
  valeur: number;
  ischecked: boolean;
  constructor() {}
}


